import React from 'react'
import { useState } from 'react'
import CardDiamondInfoProduct from '../../molecules/card-diamond-info-product/card-diamond-info-product'

import './products-info-cards.scss'

import jabonIntimo from '../../../assets/images/section-hygiene/product-soap.png'
import wetTowel from '../../../assets/images/section-hygiene/product-wet-towels.png'
import diaryPackage from '../../../assets/images/section-hygiene/product-diary-protectors.png'

const sello_olor = (
  <div key={'s01'} className="f-products-info-cards__seal --olor"></div>
)
const sello_ph = (
  <div key={'s02'} className="f-products-info-cards__seal --ph"></div>
)
const sello_gine = (
  <div key={'s03'} className="f-products-info-cards__seal --gine"></div>
)

const infoCards = [
  {
    image: jabonIntimo,
    title: 'Jabón Íntimo',
    description: (
      <>
        Usa el Jabón Íntimo todos los días en la ducha para que tu zona íntima
        esté siempre protegida
      </>
    ),
    footer: [sello_gine, sello_ph, sello_olor],
  },
  {
    image: wetTowel,
    title: 'Pañitos Húmedos',
    description: (
      <>
        <b>Lleva los Pañitos Húmedos</b> a donde quieras, para sentirte como si
        acabaras de salir de la ducha.
      </>
    ),
    footer: [sello_gine, sello_ph, sello_olor],
  },
  {
    image: diaryPackage,
    title: 'Protectores Diarios',
    description: (
      <>
        <b>Como siempre estamos en Pro de tu Zona V,</b> te presentamos los
        Protectores Diarios, que generan defensas, fortaleciendo la barrera de
        tu piel. <b>¡Recuerda cambiarlos 3 veces al día!</b>
      </>
    ),
    footer: [sello_gine, sello_ph],
  },
]

const mouseIsOnCard = (selector, callback) => {
  let div = null
  const mousemovehandler = evt => {
    // ALWAYS CALL THIS CUZ MAYBE IS NOT READY
    if (!div) {
      div = document.querySelector(selector)
      return
    }

    if (div.contains(evt.target)) {
      // IS HIS CHILD
      return
    }
    if (div !== evt.target) {
      // IS NOT HIM
      removeHandler()
    }
  }
  const removeHandler = () => {
    document.removeEventListener('mousemove', mousemovehandler)
    callback()
  }
  setTimeout(() => {
    document.addEventListener('mousemove', mousemovehandler, false)
  }, 500)
}
const ProductsInfoCards = () => {
  const [open, setOpen] = useState(0)
  const [canOpen, setCanOpen] = useState(true)

  const handlerOpen = num => {
    if (canOpen && open === 0) {
      setOpen(num)
      setCanOpen(false)
      // THIS IS LEAVE... BUT WILL NOT BE IMPLEMENTED.
      // mouseIsOnCard(
      //   '.f-products-info-cards__card-full-wrapper>div',
      //   handlerClose
      // )
    }
  }
  const handlerClose = () => {
    setOpen(0)
    setTimeout(() => {
      setCanOpen(true)
    }, 500)
  }

  const cards = (
    <>
      <div className="f-products-info-cards__card-wrapper">
        <CardDiamondInfoProduct
          className="--card-1"
          key={1}
          num={1}
          title={infoCards[0].title}
          image={infoCards[0].image}
          footer="¡Úsalo a diario en la ducha!"
          onClick={handlerOpen}
        />
      </div>
      <div className="f-products-info-cards__card-wrapper">
        <CardDiamondInfoProduct
          className="--card-2"
          key={2}
          num={2}
          title={infoCards[1].title}
          image={infoCards[1].image}
          footer="¡Llévalos a donde quieras!"
          onClick={handlerOpen}
        />
      </div>
      <div className="f-products-info-cards__card-wrapper">
        <CardDiamondInfoProduct
          className="--card-3"
          key={3}
          num={3}
          title={infoCards[2].title}
          image={infoCards[2].image}
          footer="¡Cámbialos 3 veces al día!"
          onClick={handlerOpen}
        />
      </div>
      <div className="f-products-info-cards__card-wrapper --down"></div>
    </>
  )

  return (
    <div className="f-products-info-cards">
      {open === 0 ? (
        cards
      ) : (
        <div className="f-products-info-cards__card-full-wrapper">
          <CardDiamondInfoProduct
            key={4}
            className={' --full-size ' + ('--card-' + open)}
            title={infoCards[open - 1].title}
            image={infoCards[open - 1].image}
            footer={infoCards[open - 1].footer}
            description={infoCards[open - 1].description}
            num={open}
            open={true}
            onClick={handlerClose}
          />
        </div>
      )}
    </div>
  )
}
export default ProductsInfoCards
